import React from "react";
import "../css/paysuccess.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const PaySuccess = () => {
  return (
    <>
      <div className="successDiv">
        <div className="success-container">
          <div className="modal-content">
            <div className="checkmark-circle">
              <FontAwesomeIcon icon={faCheck} />
            </div>
            <h1>Payment successful</h1>
            <p>Your order has been received and is now being processed.</p>
            <Link className="payment-result-link" to="/shop">
              Continue shopping
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaySuccess;
